export const GET_ROLE_PERMISSIONS = "GET_ROLE_PERMISSIONS"
export const GET_ROLE_PERMISSIONS_FAIL = "GET_ROLE_PERMISSIONS_FAIL"
export const GET_ROLE_PERMISSIONS_SUCCESS = "GET_ROLE_PERMISSIONS_SUCCESS"

export const ADD_NEW_ROLE_PERMISSION = "ADD_NEW_ROLE_PERMISSION"
export const ADD_ROLE_PERMISSION_SUCCESS = "ADD_ROLE_PERMISSION_SUCCESS"
export const ADD_ROLE_PERMISSION_FAIL = "ADD_ROLE_PERMISSION_FAIL"

export const UPDATE_ROLE_PERMISSION = "UPDATE_ROLE_PERMISSION"
export const UPDATE_ROLE_PERMISSION_SUCCESS = "UPDATE_ROLE_PERMISSION_SUCCESS"
export const UPDATE_ROLE_PERMISSION_FAIL = "UPDATE_ROLE_PERMISSION_FAIL"

export const DELETE_ROLE_PERMISSION = "DELETE_ROLE_PERMISSION"
export const DELETE_ROLE_PERMISSION_SUCCESS = "DELETE_ROLE_PERMISSION_SUCCESS"
export const DELETE_ROLE_PERMISSION_FAIL = "DELETE_ROLE_PERMISSION_FAIL"





